import axios from "axios";
import { useContext, useEffect, useReducer, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { UserDataContext } from "store/UserContext.jsx";
import ErrorHandler from "utils/ErrorHandler";
import { DecodeJWT } from "./helpers";

let baseURL = process?.env?.REACT_APP_ENDPOINT;
const dataFetchReducer = (state, action) => {
    switch (action.type) {
        case "FETCH_INIT":
            return {
                loading: true,
                error: false,
                response: null,
            };
        case "FETCH_SUCCESS":
            return {
                loading: false,
                error: false,
                response: action.payload,
            };
        case "FETCH_FAILURE":
            return {
                loading: false,
                error: action.payload,
                response: null,
            };
        default:
            throw new Error();
    }
};

export const useAxios = (axiosParams) => {
    const navLocation = useLocation().pathname;
    const history = useHistory();
    const [setToken] = useContext(UserDataContext);

    const initialResult = {
        loading: false,
        error: false,
        response: null,
    };

    const [result, dispatch] = useReducer(dataFetchReducer, initialResult);
    const [params, setParams] = useState(axiosParams);

    axios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(
        localStorage.getItem("access_token")
    )}`;

    const setAccessToken = (data, callback) => {
        localStorage.setItem("access_token", JSON.stringify(data.access_token));
        localStorage.setItem(
            "refresh_token",
            JSON.stringify(data.refresh_token)
        );
        dispatch({ type: "FETCH_FAILURE" });
        callback(params);
    };

    const fetchData = (args) => {
        dispatch({ type: "FETCH_INIT" });
        axios({
            method: args.method,
            url: args.url ? baseURL + args.url : args?.mock_url,
            params: args.params,
            data: args.data,
        })
            .then((result) => {
                if (args.url !== "/auth/refresh") {
                    dispatch({ type: "FETCH_SUCCESS", payload: result.data });
                } else {
                    setAccessToken(result.data, fetchData);
                }
            })
            .catch((error) => {
                if (error.response) {
                    dispatch({ type: "FETCH_FAILURE", payload: error });
                    error.response?.status !== 401 &&
                        error.response?.status !== 402 &&
                        ErrorHandler({
                            error,
                            className: "test",
                            hasCancel: args?.url?.includes(
                                "upload-finance-report"
                            )
                                ? true
                                : false,
                        });
                    if (error.response?.status === 401) {
                        fetchData({
                            method: "post",
                            url: "/auth/refresh",
                            data: {
                                refresh_token: JSON.parse(
                                    localStorage.getItem("refresh_token")
                                ),
                            },
                        });
                    }
                    if (error.response?.status === 402) {
                        history.push("/");
                        localStorage.removeItem("access_token");
                        setToken(null);
                    }
                }
            });
    };

    useEffect(() => {
        const decoded_token = localStorage.getItem("access_token")
            ? DecodeJWT(JSON.parse(localStorage.getItem("access_token")))
            : null;

        if (params) {
            if (Date.now() < decoded_token?.exp * 1000 || navLocation === "/") {
                fetchData(params);
            } else {
                fetchData({
                    method: "post",
                    url: "/auth/refresh",
                    data: {
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token")
                        ),
                    },
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    return [result, setParams];
};
